import { ReactComponent as Home } from 'assets/icons/icon-home.svg';

export default Home;
